import * as React from "react";

import { NavigationTab } from "./navigation-tab";

interface NavigationBarProps {
  ContentRoutes: {
    [key: string]: string;
  };
  selectedContentRoute: string;
  onUserWantsToSelectContentRoute: (contentRoute: string) => void;
}

export const NavigationBar: React.FunctionComponent<NavigationBarProps> = (
  props
) => {
  const navigationTabs = React.useMemo(() => {
    return Object.values(props.ContentRoutes).map((route) => (
      <NavigationTab
        route={route}
        selectedContentRoute={props.selectedContentRoute}
        onUserWantsToSelectContentRoute={props.onUserWantsToSelectContentRoute}
      />
    ));
  }, [
    props.ContentRoutes,
    props.selectedContentRoute,
    props.onUserWantsToSelectContentRoute,
  ]);
  return (
    <div className="navigation-bar">
      <div className="navigation-tabs">{navigationTabs}</div>
    </div>
  );
};
